import { render, staticRenderFns } from "./HandBook.vue?vue&type=template&id=61e665cc"
import script from "./HandBook.vue?vue&type=script&lang=js"
export * from "./HandBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports